import React, { useState } from 'react';
import { Mail, CheckCircle, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const NewsletterSection = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');
    
    try {
      const response = await fetch(`${API_URL}/api/newsletter.php?action=subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await response.json();
      
      if (response.ok) {
        setStatus('success');
        setMessage('Uspešno ste se prijavili!');
        setEmail('');
      } else {
        setStatus('error');
        setMessage(data.error || 'Došlo je do greške');
      }
    } catch (error) {
      setStatus('error');
      setMessage('Došlo je do greške. Pokušajte ponovo.');
    }
    
    setTimeout(() => {
      setStatus('idle');
      setMessage('');
    }, 5000);
  };

  return (
    <section className="newsletter-section">
      <div className="section-container">
        <div className="newsletter-content">
          <div className="newsletter-text">
            <span className="section-label">NEWSLETTER</span>
            <h2 className="newsletter-title">BUDITE U TOKU</h2>
            <p className="newsletter-description">
              Prijavite se za naš newsletter i prvi saznajte o novim proizvodima, 
              ekskluzivnim ponudama i specijalnim popustima.
            </p>
          </div>
          
          <form className="newsletter-form" onSubmit={handleSubmit}>
            {status === 'success' ? (
              <div className="newsletter-success">
                <CheckCircle size={24} />
                <span>{message}</span>
              </div>
            ) : (
              <>
                <div className="newsletter-input-wrapper">
                  <Mail size={20} className="newsletter-icon" />
                  <input
                    type="email"
                    placeholder="Vaša email adresa"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="newsletter-input"
                    disabled={status === 'loading'}
                    required
                  />
                </div>
                <button 
                  type="submit" 
                  className="newsletter-button"
                  disabled={status === 'loading'}
                >
                  {status === 'loading' ? <Loader2 size={20} className="spin" /> : 'Prijavi se'}
                </button>
              </>
            )}
            {status === 'error' && <p className="newsletter-error">{message}</p>}
          </form>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
